import { render, staticRenderFns } from "./NonLoginSharingMatchResults.vue?vue&type=template&id=f4abf606&scoped=true"
import script from "./NonLoginSharingMatchResults.vue?vue&type=script&lang=ts"
export * from "./NonLoginSharingMatchResults.vue?vue&type=script&lang=ts"
import style0 from "./NonLoginSharingMatchResults.vue?vue&type=style&index=0&id=f4abf606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4abf606",
  null
  
)

export default component.exports